var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import React from 'react';
import colors from '../../themes/colors';
var VARIANT_MAPPING = {
    inherit: 'p'
};
var terminaVariants = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
var StyledTyphography = styled(Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transition: color 0.5s ease-in-out;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"], ["\n  transition: color 0.5s ease-in-out;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"])));
var Text = React.forwardRef(function (props, ref) {
    var _a = props.variant, variant = _a === void 0 ? 'body1' : _a, children = props.children, _b = props.isTermina, isTermina = _b === void 0 ? true : _b, textColor = props.color, _c = props.ellipsis, ellipsis = _c === void 0 ? false : _c, className = props.className;
    var color = textColor !== null && textColor !== void 0 ? textColor : 'inherit';
    if (textColor) {
        // @ts-ignore
        if (textColor in colors.legacy)
            color = colors.legacy[textColor];
        // @ts-ignore
        if (textColor in colors)
            color = colors[textColor];
    }
    var TypographyComponent = ellipsis ? StyledTyphography : Typography;
    var terminaFontClass = terminaVariants.includes(variant) && isTermina ? 'termina-header' : '';
    return (_jsx(TypographyComponent, __assign({ className: "".concat(className, " ").concat(terminaFontClass), ref: ref, sx: { color: color }, variantMapping: VARIANT_MAPPING, variant: variant }, { children: children })));
});
export default Text;
var templateObject_1;
